export default "__VITE_ASSET__y2ggul$Q__"